// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Empty_margin__20Mqr {\n  margin-top: 90px;\n}\n.Empty_error__1xuEK {\n  width: 100%;\n  font-weight: bold;\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Navigation/Empty.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".margin {\n  margin-top: 90px;\n}\n.error {\n  width: 100%;\n  font-weight: bold;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"margin": "Empty_margin__20Mqr",
	"error": "Empty_error__1xuEK"
};
export default ___CSS_LOADER_EXPORT___;
